import React from 'react'
import CustomPath from './CustomPath'

const OUTLINE_PATH = 'M0 0H56V56H0V0Z'
const RAW_WIDTH = 56
const RAW_HEIGHT = 56

/**
 * Square shape component
 * @type {import('./CustomPath').CustomPath}
 */
export const SquareShape = React.forwardRef((props, ref) => {
    return <CustomPath {...props} ref={ref} data={OUTLINE_PATH} rawWidth={RAW_WIDTH} rawHeight={RAW_HEIGHT} />
})

export default SquareShape
